import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'

export function useTaskSections() {
  const [sections, setSections] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchSections()
  }, [])

  const fetchSections = async () => {
    try {
      setLoading(true)
      const { data, error: err } = await supabase
        .from('task_sections')
        .select('*')
        .order('sort_order')
      if (err) throw err
      setSections(data || [])
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const createSection = async (name, color = '#6366f1') => {
    const { data, error } = await supabase
      .from('task_sections')
      .insert([{ name, color, sort_order: sections.length }])
      .select()
    if (error) throw error
    await fetchSections()
    return data[0]
  }

  const updateSection = async (id, updates) => {
    const { data, error } = await supabase
      .from('task_sections')
      .update(updates)
      .eq('id', id)
      .select()
    if (error) throw error
    await fetchSections()
    return data[0]
  }

  const deleteSection = async (id) => {
    const { error } = await supabase.from('task_sections').delete().eq('id', id)
    if (error) throw error
    await fetchSections()
  }

  return {
    sections,
    loading,
    error,
    createSection,
    updateSection,
    deleteSection,
    refetch: fetchSections,
  }
}
